import * as Const from '../../constants';

import * as SubmitIcon from '../../../../assets/image/succesMessage.png';
import * as WarningIcon from '../../../../assets/image/warning.png';
import * as ErrorIcon from '../../../../assets/image/documentError.png';

export default function toasterPickIcon (messageType): File {
  switch (messageType) {

    case Const.MESSAGE_TYPE.success:
      return SubmitIcon;

    case Const.MESSAGE_TYPE.warning:
      return WarningIcon;

    case Const.MESSAGE_TYPE.fail:
      return ErrorIcon;

    default:
      return WarningIcon;
  }
}
